import { twMerge } from '@/lib/classname/twMerge'
import { type VariantProps, cva } from 'class-variance-authority'
import type { PropsWithChildren } from 'react'
import './Skin.css'

const tintVariants = {
  // Lighter skins
  body: 'bg-white text-brand-2-900',
  'body-alt': 'bg-brand-2-50 text-brand-2-900',
  'brand-1-light': 'bg-brand-1-50 text-brand-2-900',
  // Darker skins
  'brand-1': 'bg-brand-1-700 text-white',
  'brand-1-alt': 'bg-brand-1-600 text-white',
  'brand-2': 'bg-brand-2-900 text-white',
}

const skinCva = cva('', {
  variants: {
    tint: tintVariants,
  },
})

export type SkinTint = keyof typeof tintVariants
export const skinTintVariants = Object.keys(tintVariants) as SkinTint[]

type SkinVariantProps = Required<VariantProps<typeof skinCva>>

export type SkinProps = UiComponentProps<PropsWithChildren<SkinVariantProps>>

export const skinCssClassMap: Record<SkinTint, string> = {
  body: 'skin-body',
  'body-alt': 'skin-body-alt',
  'brand-1-light': 'skin-brand-1-light',
  'brand-1': 'skin-brand-1',
  'brand-1-alt': 'skin-brand-1-alt',
  'brand-2': 'skin-brand-2',
}

export function Skin({
  tint,
  children,
  id,
  className,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
}: SkinProps) {
  return (
    <div
      id={id}
      aria-label={ariaLabel}
      className={twMerge(className, skinCva({ tint }), skinCssClassMap[tint!])}
      data-testid={dataTestId ?? 'skin'}
    >
      {children}
    </div>
  )
}
